export default __webpack_public_path__ + "static/gift-card-8.url-6d9bc8edec0775f8ed41cd4074544163.svg";